/* eslint-disable promise/param-names */
import * as authTypes from '@/store/actions/auth'
import * as userTypes from '@/store/actions/user'
import * as appTypes from '@/store/actions/app'
import * as api from '@/utils/api'
import Configuration from '@/configuration'
import moment from 'moment'
import axios from 'axios'

const state = {
  status: null,
  hasLoadedOnce: false,
  logged: false,
  rememberOperationId: null,
  rememberOperationTime: 60 * 1000 * 10,
  rememberCodeAttempts: 0
}

const getters = {
  [authTypes.AUTH_AUTHENTICATED]: state => state.logged,
  [authTypes.AUTH_STATUS]: state => state.status,
  [authTypes.REMEMBER_OPERATION_ID]: state => state.rememberOperationId,
  [authTypes.REMEMBER_OPERATION_TIME]: state => state.rememberOperationTime,
  [authTypes.REMEMBER_CODE_ATTEMPTS]: state => state.rememberCodeAttempts
}

const actions = {
  [authTypes.AUTH_REQUEST]: ({commit, dispatch}, user) => {
    dispatch(`${authTypes.AUTH_FIRST_CHECK_LOGGED}`, null)
  },
  [authTypes.REMEMBER_REQUEST]: ({commit}, user) => {
    return new Promise((resolve, reject) => {
      commit(authTypes.AUTH_REQUEST)
      setTimeout(function () {
        api.call({access: api.ACCESS_AUTHENTICATION, url: '/auth/remember', method: 'POST', data: user})
          .then(resp => {
            resolve(resp)
            commit(authTypes.SET_STATUS, 'remember-code')
            commit(authTypes.REMEMBER_OPERATION_ID, resp)
          })
          .catch(err => {
            reject(err)
            setTimeout(function () {
              if (err.response) {
                commit(authTypes.AUTH_ERROR, {err: err.response.status + ''})
              } else {
                commit(authTypes.AUTH_ERROR, {err: {response: {status: 500}}})
              }
            }, 500)
          })
      }, 500)
    })
  },
  [authTypes.REMEMBER_CODE_REQUEST]: ({commit, rootGetters}, rememberCode) => {
    return new Promise((resolve, reject) => {
      commit(authTypes.AUTH_REQUEST)
      setTimeout(function () {
        api.call({access: api.ACCESS_REMEMBER_CODE, url: '/auth/rememberCode', method: 'POST', data: rememberCode})
          .then(resp => {
            resolve(resp)
            commit(authTypes.SET_STATUS, 'repeat-password')
            commit(authTypes.REMEMBER_OPERATION_ID, resp)
          })
          .catch(err => {
            reject(err)
            commit(authTypes.REMEMBER_CODE_ATTEMPTS)
            setTimeout(function () {
              if (err.response) {
                if (rootGetters[`${authTypes.AUTH_NAMESPACE}/${authTypes.REMEMBER_CODE_ATTEMPTS}`] < 3) {
                  commit(authTypes.AUTH_ERROR, {err: err.response.status + ''})
                }
              } else {
                commit(authTypes.AUTH_ERROR, {err: {response: {status: 500}}})
              }
            }, 500)
          })
      }, 500)
    })
  },
  [authTypes.REMEMBER_NEW_PASSWORD_REQUEST]: ({commit}, newPassword) => {
    return new Promise((resolve, reject) => {
      commit(authTypes.AUTH_REQUEST)
      setTimeout(function () {
        api.call({access: api.ACCESS_REMEMBER_CODE, url: '/auth/rememberPassword', method: 'POST', data: newPassword})
          .then(resp => {
            resolve(resp)
            commit(authTypes.REMEMBER_OPERATION_ID_RESET)
            commit(authTypes.SET_STATUS, 'password-setted')
          })
          .catch(err => {
            reject(err)
            setTimeout(function () {
              if (err.response) {
                commit(authTypes.AUTH_ERROR, {err: err.response.status + ''})
              } else {
                commit(authTypes.AUTH_ERROR, {err: {response: {status: 500}}})
              }
            }, 500)
          })
      }, 500)
    })
  },
  [authTypes.AUTH_REQUEST_LOADING]: ({commit}) => {
    commit(authTypes.AUTH_REQUEST)
  },
  [authTypes.AUTH_FIRST_CHECK_LOGGED]: ({commit, dispatch}, to) => {
    dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, true, {root: true})
    if (to) {
      window.localStorage.setItem('full-path-redirect', JSON.stringify(to))
    }
    return new Promise((resolve, reject) => {
      // token Sherpa setejat: petició directa a 'profile'
      if (window.localStorage.getItem('user-token') && window.localStorage.getItem('user-token') !== '') {
        api.call({access: api.ACCESS_AUTHENTICATION, url: '/auth/profile', method: 'POST'})
          .then(resp => {
            dispatch(`${userTypes.USER_NAMESPACE}/${userTypes.USER_REQUEST}`, resp, {root: true})
            dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_MENU}`, JSON.parse(window.localStorage.getItem('full-path-redirect')), {root: true})
            // commit(authTypes.AUTH_SUCCESS)
            resolve(resp)
          })
          .catch(err => {
            window.localStorage.removeItem('user-token')
            window.localStorage.removeItem('oauth-token')

            dispatch(`${authTypes.AUTH_FIRST_CHECK_LOGGED}`, null)
            reject(err)
          })

      // token CCOO no setejat: redirigim a l'aplicatiu extern de login
      } else if (!window.localStorage.getItem('oauth-token')) {
        let keycloakUrl = Configuration.value('REALM_URL')
        let realm = Configuration.value('REALM_REALM')
        let clientId = Configuration.value('REALM_CLIENT_ID')
        let redirectUri = Configuration.value('REALM_REDIRECT_URI')
        window.location.href = `${keycloakUrl}/realms/${realm}/protocol/openid-connect/auth?response_type=code&client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}`

      // token CCOO setejat: fer la petició a externalauth per obtenir les dades de l'usuari
      } else {
        api.call({access: api.ACCESS_AUTHENTICATION, url: '/auth/externalauth', method: 'POST'})
          .then(resp => {
            dispatch(`${authTypes.AUTH_FIRST_CHECK_LOGGED}`, null)
            resolve(resp)
          })
          .catch(err => {
            window.localStorage.removeItem('user-token')
            window.localStorage.removeItem('oauth-token')
            // not valid roles
            if (err.response.status === 412) {
              dispatch(`${authTypes.AUTH_STATUS_ERROR}`, err)
              dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, false, {root: true})
            } else {
              dispatch(`${authTypes.AUTH_FIRST_CHECK_LOGGED}`, null)
            }

            reject(err)
          })
      }
    })
  },
  [authTypes.AUTH_REALM_LOGIN]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(authTypes.AUTH_REQUEST)
      let accessToken = window.localStorage.getItem('user-token')
      if (!accessToken || accessToken === '') {
        let code = window.location.search.split('code=')[1]
        let keycloakUrl = Configuration.value('REALM_URL')
        let realm = Configuration.value('REALM_REALM')
        if (code) {
          let tokenData = {
            grant_type: Configuration.value('REALM_GRANT_TYPE'),
            client_id: Configuration.value('REALM_CLIENT_ID'),
            redirect_uri: Configuration.value('REALM_REDIRECT_URI'),
            code: code,
            scope: Configuration.value('REALM_OPEN_ID')
          }
          resolve(
            axios.post(`${keycloakUrl}/realms/${realm}/protocol/openid-connect/token`,
              new URLSearchParams(tokenData), {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
              }).then(response => {
              window.localStorage.setItem('oauth-token', JSON.stringify(response.data))
              dispatch(`${authTypes.AUTH_FIRST_CHECK_LOGGED}`, null)
            })
              .catch(error => {
                console.error(error)
                window.localStorage.removeItem('oauth-token')
                dispatch(`${authTypes.AUTH_FIRST_CHECK_LOGGED}`, null)
              })
          )
        }
      }
    })
  },
  [authTypes.AUTH_LOGOUT]: ({commit, dispatch}, params) => {
    return new Promise((resolve, reject) => {
      commit(authTypes.AUTH_LOGOUT)
      if (window.localStorage.getItem('user-token')) {
        var data = new Blob(
          [
            window.localStorage.getItem('user-token')
          ],
          {
            type: 'application/x-json'
          }
        )
        navigator.sendBeacon(Configuration.value('API_SERVICES_URL') + moment().valueOf() + '/auth/logout', data)

        if (params && params.removeToken) {
          window.localStorage.removeItem('user-token')
          dispatch(`${userTypes.USER_NAMESPACE}/${authTypes.AUTH_LOGOUT}`, { }, {root: true})
          commit(authTypes.AUTH_SUCCESS)
        }
        resolve()
      }
    })
  },
  [authTypes.AUTH_SUCCESS]: ({commit}) => {
    commit(authTypes.AUTH_SUCCESS)
  },
  [authTypes.AUTH_STATUS_ERROR]: ({commit}, error) => {
    if (error.response) {
      commit(authTypes.AUTH_STATUS_ERROR, {err: error.response.status + ''})
    }
  },
  [authTypes.AUTH_STATUS_RESET]: ({commit}) => {
    commit(authTypes.AUTH_STATUS_RESET)
  },
  [authTypes.REMEMBER_OPERATION_ID_RESET]: ({commit}) => {
    commit(authTypes.REMEMBER_OPERATION_ID_RESET)
  }
}

const mutations = {
  [authTypes.AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [authTypes.AUTH_STATUS_RESET]: (state) => {
    state.status = null
    state.rememberOperationId = null
    state.rememberCodeAttempts = 0
  },
  [authTypes.REMEMBER_OPERATION_ID_RESET]: (state) => {
    state.rememberOperationId = null
    state.rememberCodeAttempts = 0
  },
  [authTypes.REMEMBER_CODE_ATTEMPTS]: (state) => {
    state.rememberCodeAttempts += 1
  },
  [authTypes.AUTH_SUCCESS]: (state) => {
    state.status = 'success'
    state.hasLoadedOnce = true
    state.logged = (window.localStorage.getItem('user-token') && window.localStorage.getItem('user-token') !== '')
  },
  [authTypes.SET_STATUS]: (state, status) => {
    state.status = status
  },
  [authTypes.REMEMBER_OPERATION_ID]: (state, operationId) => {
    state.rememberOperationId = operationId
  },
  [authTypes.AUTH_ERROR]: (state, {err}) => {
    state.status = err
    state.hasLoadedOnce = true
    state.logged = false
  },
  [authTypes.AUTH_STATUS_ERROR]: (state, {err}) => {
    state.status = err
  },
  [authTypes.AUTH_LOGOUT]: (state) => {
    state.logged = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js